import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <div className="bg-wellness-beige rounded-2xl p-8 md:p-12 max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8 border border-wellness-darkBeige shadow-sm" data-id="element-59">
      <div className="flex-shrink-0 bg-white p-4 rounded-full shadow-md" data-id="element-60">
        <ShieldCheckIcon className="w-16 h-16 text-wellness-gold" data-id="element-61" />
      </div>
      <div className="text-center md:text-left" data-id="element-62">
        <h3 className="text-2xl font-bold mb-3 text-wellness-dark" data-id="element-63">
          Garantía de Satisfacción de 7 Días
        </h3>
        <p className="text-wellness-body leading-relaxed" data-id="element-64">
          Estamos tan seguros de que este programa transformará tu salud, que te
          ofrecemos una garantía incondicional. Si en 7 días no sientes una
          mejora en tu digestión, energía y bienestar general, te devolvemos el
          100% de tu dinero. Sin preguntas, sin complicaciones.
        </p>
      </div>
    </div>;
}